import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class SubventionFilter extends Component {
    state = {
        subventionLists:[],
        subventionValue: '',
        isSubventionLoading: true
    };
    componentDidMount(){
        this.getSubvention();
    }

    resetSubventionFilter(){
        this.setState({
        subventionValue: [],
        })
    }
    getSubvention(){
        axios.get(config.get('API_URL')+'/filters/get-subvention/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((subvention, index) => {
                    this.state.subventionLists.push({value: subvention.subvention_code, label: subvention.subvention_display_name})
                });
            }
            this.setState({
                loading:false,
                isSubventionLoading: false
            })
        });

    }
    changeSubvention(optionSelected){
        let value='';
        let subArray = [];
        if(optionSelected.length < 1){
            value = null;
            subArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                subArray.push(mids.value)
            });
        }
        this.props.onSelectSubvention(optionSelected,subArray);
        this.setState({
            subventionValue:optionSelected,
        });
    }


    render() {

        return (
            <ReactMultiSelectCheckboxes name="subvention"
                value={this.state.subventionValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeSubvention.bind(this)}
                options={this.state.subventionLists}
                isLoading={this.state.isSubventionLoading}
                placeholderButtonLabel=" Select [Subvention]"
            />
        );

    }
}
export default SubventionFilter;